import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUserDetail, updateProfile, changePassword } from '../services/api';

export const fetchUserDetails = createAsyncThunk(
  'user/details',
  async (_, { rejectWithValue }) => {
    try {
      console.log('Fetching user details...');
      const response = await getUserDetail();
      console.log('API Response Data:', response.data);
      return response.data;
    } catch (error) {
      console.log('Error in fetchUserDetails:', error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateUserProfile = createAsyncThunk(
  'user/updateProfile',
  async (userData, { rejectWithValue }) => {
    try {
      console.log('Updating profile with data:', userData);
      const response = await updateProfile(userData);
      console.log('Update Profile Response:', response.data);
      return response.data;
    } catch (error) {
      console.log('Error in updateUserProfile:', error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const changeUserPassword = createAsyncThunk(
  'user/changePassword',
  async (passwords, { rejectWithValue }) => {
    try {
      const response = await changePassword(passwords);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const userSlice = createSlice({
  name: 'user',
  initialState: {
    details: {
      status: false,
      userDetail: null
    },
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserDetails.pending, (state) => {
        console.log('Fetch User Details Pending...');
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserDetails.fulfilled, (state, action) => {
        console.log('Fetch User Details Fulfilled with:', action.payload);
        state.loading = false;
        state.details = action.payload;
      })
      .addCase(fetchUserDetails.rejected, (state, action) => {
        console.log('Fetch User Details Rejected:', action.payload);
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateUserProfile.fulfilled, (state, action) => {
        console.log('Update Profile Fulfilled with:', action.payload);
        if (state.details) {
          state.details.userDetail = { ...state.details.userDetail, ...action.payload };
        }
      });
  },
});

export default userSlice.reducer;